module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_hometown-9167e21079792428598c986124545e71.webp";